var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import * as mapboxgl from 'mapbox-gl';
import { TransitionDirection, LayerTransitionType } from './types';
import { equals } from '@core/helper/operators';
import * as turf from '@turf/turf';
import { distance } from '@core/helper/vector';
import * as polylabel from 'polylabel';
var TCMap = /** @class */ (function (_super) {
    __extends(TCMap, _super);
    function TCMap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TCMap.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.map = new mapboxgl.Map({
                    container: this.$refs.map,
                    center: [this.defaultLongitude, this.defaultLatitude],
                    bearing: this.defaultBearing,
                    pitch: this.defaultPitch,
                    minZoom: this.minZoom,
                    maxZoom: this.maxZoom,
                    zoom: this.defaultZoom,
                    style: this.styleUrl,
                    hash: this.syncMapLocationWithUrl,
                    interactive: this.isInteractive,
                    attributionControl: true,
                    trackResize: true,
                    // MS Edge defaults to 'omit'. Force 'same-origin' so that credentials are present.
                    transformRequest: function (url, resourceType) {
                        return {
                            url: url,
                            credentials: 'same-origin'
                        };
                    }
                });
                if (this.isFullscreenToggleEnabled) {
                    this.map.addControl(new mapboxgl.FullscreenControl());
                }
                this.map.on('load', this.onMapLoad);
                console.log(this.sources, this.layers);
                return [2 /*return*/];
            });
        });
    };
    /** Map life cycle steps */
    TCMap.prototype.onMapLoad = function () {
        this.registerMapEvents();
        this.loadSources();
        this.loadLayers();
        this.registerLayerEvents();
        this.initTransitions();
    };
    /** Load configured Geo-Json sources to the map */
    TCMap.prototype.loadSources = function () {
        for (var sourceId in this.sources) {
            this.map.addSource(sourceId, this.sources[sourceId]);
        }
    };
    /** Load configured layers to the map. */
    TCMap.prototype.loadLayers = function () {
        for (var _i = 0, _a = this.layers; _i < _a.length; _i++) {
            var layer = _a[_i];
            // `layers` carries app-specific extra fields (interactive, metadata) on top of
            // the base mapbox-gl layer shape, so it's typed loosely as `Layer` rather than
            // the stricter `AnyLayer` union `addLayer` expects.
            this.map.addLayer(layer);
        }
    };
    /** Register global map events. */
    TCMap.prototype.registerMapEvents = function () {
        var _this = this;
        this.map.on('mousemove', function (e) { return _this.onMapMouseMove(e); });
        window.addEventListener('resize', function (e) {
            console.log('received resize from window');
            if (e instanceof CustomEvent) {
                _this.map.resize();
            }
        });
    };
    /** Register layer events based on layer interactivity setting. */
    TCMap.prototype.registerLayerEvents = function () {
        var _this = this;
        var _loop_1 = function (layer) {
            if (layer.interactive) {
                this_1.map.on('mousemove', layer.id, function (e) { return _this.onLayerMouseMove(layer, e); });
                this_1.map.on('mouseenter', layer.id, function (e) { return _this.onLayerMouseEnter(layer, e); });
                this_1.map.on('mouseleave', layer.id, function (e) { return _this.onLayerMouseLeave(layer, e); });
                this_1.map.on('click', layer.id, function (e) { return _this.onLayerClick(layer, e); });
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = this.layers; _i < _a.length; _i++) {
            var layer = _a[_i];
            _loop_1(layer);
        }
    };
    TCMap.prototype.onMapMouseMove = function (e) {
        this.tryResetCurrentFeatureUnderMouse(e.lngLat);
    };
    TCMap.prototype.onLayerClick = function (layer, e) {
        if (!layer.interactive) {
            return;
        }
        var feature = e.features[0];
        var popupData = JSON.parse(feature.properties.popup);
        if (popupData != null) {
            this.openFeaturePopup(feature, popupData);
        }
    };
    TCMap.prototype.onLayerMouseMove = function (layer, e) {
        if (!layer.interactive) {
            return false;
        }
        var feature = e.features[0];
        if (layer.metadata != null && layer.metadata.hoverLayerId != null) {
            //this.map.setFilter(layer.metadata.hoverLayerId, ['==', 'id', feature.properties.id]);
            //this.hoverLayers.push(layer.metadata.hoverLayerId);
        }
    };
    TCMap.prototype.onLayerMouseEnter = function (layer, e) {
        this.map.getCanvas().style.cursor = 'pointer';
        var features = e.features;
        var feature = features[0];
        if (this.currentFeatureUnderMouse == feature) {
            return;
        }
        this.currentFeatureUnderMouse = feature;
        var tooltipData = JSON.parse(feature.properties.tooltip);
        if (tooltipData != null) {
            this.openFeatureTooltip(feature, tooltipData);
        }
    };
    TCMap.prototype.onLayerMouseLeave = function (layer, e) {
        this.tryResetCurrentFeatureUnderMouse(e.lngLat);
    };
    TCMap.prototype.tryResetCurrentFeatureUnderMouse = function (mouseCoords) {
        if (this.currentFeatureUnderMouse != null) {
            var isIntersecting = false;
            var mouseLngLat = [mouseCoords.lng, mouseCoords.lat];
            var mousePoint = this.map.project(mouseCoords);
            if (this.currentFeatureUnderMouse.geometry.type == 'Polygon') {
                isIntersecting = turf.booleanPointInPolygon(mouseLngLat, this.currentFeatureUnderMouse);
            }
            else if (this.currentFeatureUnderMouse.geometry.type == 'Point') {
                // GeoJSON types coordinates as a generic number[]; a Point is always
                // guaranteed to be exactly [longitude, latitude] per the GeoJSON spec.
                var featurePoint = this.map.project(this.currentFeatureUnderMouse.geometry.coordinates);
                isIntersecting = distance(mousePoint, featurePoint) < 16;
            }
            if (!isIntersecting) {
                this.map.getCanvas().style.cursor = '';
                //this.resetHoverLayers();
                //this.currentTooltipPopup.remove();
                this.currentFeatureUnderMouse = null;
                this.closeCurrentFeatureTooltip();
            }
        }
    };
    TCMap.prototype.openFeaturePopup = function (feature, data) {
        var _this = this;
        if (this.activeFeaturePopupObjectId == feature.properties.objectId) {
            return;
        }
        var popup = new mapboxgl.Popup({
            className: 'tc-mapboxgl-popup',
        });
        this.activeFeaturePopupObjectId = feature.properties.objectId;
        popup.on('close', function (e) { return _this.onFeaturePopupClosed(feature, e); });
        this.openPopupOnFeature(feature, data, popup);
    };
    TCMap.prototype.onFeaturePopupClosed = function (feature, e) {
        this.activeFeaturePopupObjectId = null;
    };
    TCMap.prototype.openFeatureTooltip = function (feature, data) {
        this.closeCurrentFeatureTooltip();
        this.currentFeatureTooltip = new mapboxgl.Popup({
            closeButton: false,
            anchor: 'left',
            className: 'is-tooltip tc-mapboxgl-popup',
            closeOnClick: false,
        });
        this.openPopupOnFeature(feature, data, this.currentFeatureTooltip);
    };
    TCMap.prototype.openPopupOnFeature = function (feature, data, popup) {
        return __awaiter(this, void 0, void 0, function () {
            var featureType, popupLngLat, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        featureType = feature.geometry.type;
                        if (featureType == 'Point') {
                            popupLngLat = feature.geometry.coordinates;
                        }
                        else if (featureType == 'Polygon') {
                            popupLngLat = polylabel(feature.geometry.coordinates);
                        }
                        popup
                            .setLngLat(popupLngLat)
                            .setHTML('<i class="fas fa-circle-notch fa-spin"></i>')
                            .addTo(this.map);
                        if (!(data.content != null)) return [3 /*break*/, 1];
                        if (typeof data.content == 'string') {
                            popup.setText(data.content);
                        }
                        else {
                            popup.setHTML(data.content.html);
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        if (!(data.renderUrl != null)) return [3 /*break*/, 4];
                        return [4 /*yield*/, fetch(data.renderUrl, {
                                method: 'GET',
                                credentials: 'include',
                                headers: {
                                    'X-Requested-With': 'XMLHttpRequest',
                                    'X-TableRequest-Type': 'Update'
                                }
                            })];
                    case 2: return [4 /*yield*/, (_a.sent()).text()];
                    case 3:
                        result = _a.sent();
                        popup.setHTML(result);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TCMap.prototype.closeCurrentFeatureTooltip = function () {
        if (this.currentFeatureTooltip != null) {
            this.currentFeatureTooltip.remove();
            this.currentFeatureTooltip = null;
        }
    };
    TCMap.prototype.initTransitions = function () {
        // Iterate over layers and check if their metadata defines any transitions
        for (var _i = 0, _a = this.layers; _i < _a.length; _i++) {
            var layer = _a[_i];
            if (layer.metadata != null && 'transition' in layer.metadata && 'paint' in layer.metadata.transition) {
                this.initLayerTransitions(layer);
            }
        }
    };
    TCMap.prototype.getLayerTransitionType = function (rule) {
        if (rule.steps != null) {
            return LayerTransitionType.STEPPED;
        }
        else {
            return LayerTransitionType.VALUE;
        }
    };
    TCMap.prototype.initLayerTransitions = function (layer) {
        var _this = this;
        var meta = layer.metadata;
        var _loop_2 = function (rule) {
            // Define transition property name for the paint property (sets the transition property to make sure it is set)
            var transitionProperty = "".concat(rule.property, "-transition");
            var transitionType = this_2.getLayerTransitionType(rule);
            // If duration is set, make sure the transition of the paint property is set to it
            if (rule.duration != null) {
                this_2.map.setPaintProperty(layer.id, transitionProperty, { duration: rule.duration });
            }
            var stepIndex = 0;
            var animate = function () {
                // If the rule is not 
                if (transitionType == LayerTransitionType.STEPPED) {
                    _this.map.setPaintProperty(layer.id, rule.property, rule.steps[stepIndex]);
                    stepIndex += 1;
                    if (stepIndex == rule.steps.length) {
                        stepIndex = 0;
                    }
                }
                else {
                    var current = _this.map.getPaintProperty(layer.id, rule.property);
                    var direction = equals(current, rule.to) ? TransitionDirection.BACKWARD : TransitionDirection.FORWARD;
                    var value = direction == TransitionDirection.FORWARD ? rule.to : rule.from;
                    if (rule.transition != null) {
                        // If a directional transition is defined, apply it
                        if (rule.transition.forward != null && direction == TransitionDirection.FORWARD) {
                            _this.map.setPaintProperty(layer.id, transitionProperty, rule.transition.forward);
                        }
                        else if (rule.transition.backward != null && direction == TransitionDirection.BACKWARD) {
                            _this.map.setPaintProperty(layer.id, transitionProperty, rule.transition.backward);
                        }
                    }
                    _this.map.setPaintProperty(layer.id, rule.property, value);
                }
                if (rule.duration != null) {
                    window.setTimeout(animate, rule.duration);
                    // No duration set, animate every frame. @TODO this needs a better way of defining.
                }
                else {
                    window.requestAnimationFrame(animate);
                }
            };
            animate();
        };
        var this_2 = this;
        for (var _i = 0, _a = meta.transition.paint; _i < _a.length; _i++) {
            var rule = _a[_i];
            _loop_2(rule);
        }
    };
    __decorate([
        Prop({ type: Number })
    ], TCMap.prototype, "defaultLatitude", void 0);
    __decorate([
        Prop({ type: Number })
    ], TCMap.prototype, "defaultLongitude", void 0);
    __decorate([
        Prop({ type: Number })
    ], TCMap.prototype, "defaultPitch", void 0);
    __decorate([
        Prop({ type: Number })
    ], TCMap.prototype, "defaultBearing", void 0);
    __decorate([
        Prop({ type: Number })
    ], TCMap.prototype, "minZoom", void 0);
    __decorate([
        Prop({ type: Number })
    ], TCMap.prototype, "maxZoom", void 0);
    __decorate([
        Prop({ type: Number })
    ], TCMap.prototype, "defaultZoom", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], TCMap.prototype, "syncMapLocationWithUrl", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], TCMap.prototype, "isInteractive", void 0);
    __decorate([
        Prop({ type: String })
    ], TCMap.prototype, "styleUrl", void 0);
    __decorate([
        Prop({ type: Array })
    ], TCMap.prototype, "layers", void 0);
    __decorate([
        Prop({ type: Object })
    ], TCMap.prototype, "sources", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], TCMap.prototype, "isFullscreenToggleEnabled", void 0);
    TCMap = __decorate([
        Component({
            mixins: [],
            components: {}
        })
    ], TCMap);
    return TCMap;
}(Vue));
export default TCMap;
